// @ts-nocheck

/**
 * 仙女棒火花：五张 sprite 循环切换形成闪烁，同时随机扰动点位置并做缩放消散。
 * 该组件来自效果原型，保留 @ts-nocheck 是因为 R3F/Three 的动态材质属性类型不完整。
 */

import { useTexture } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import { useEffect, useRef } from 'react';
import { Points } from 'three';

function Sparkles({ position, amp = 1, size = 1, ...props }: any) {
    // 五帧 PNG 作为简单的序列帧动画。
    const sprites = useTexture(
        [...Array(5)].map((_, i) => `/sparkles/${i}.png`),
    );
    const points = useRef<Points>(null);
    // t 是单次火花扩散的时间；Infinity 让首次重置前的点不可见。
    const t = useRef(Infinity);
    const initialAttribute = useRef<any>();

    useEffect(() => {
        // 周期性恢复初始点位，再增加随机偏移，制造每次不同的爆散形态。
        const timer = setInterval(() => {
            requestAnimationFrame(() => {
                if (points.current) {
                    // 第一次运行时保存几何体的原始点位，后续每次从它重新出发。
                    if (!initialAttribute.current) {
                        initialAttribute.current =
                            points.current.geometry.attributes.position.clone();
                    }
                    // 复制初始坐标后施加随机扰动。
                    const positionAttribute = points.current.geometry.attributes
                        .position as any;
                    for (let i = 0; i < positionAttribute.array.length; ++i) {
                        positionAttribute.array[i] =
                            initialAttribute.current.array[i];
                        positionAttribute.array[i] +=
                            40 * size * (Math.random() - 0.5);
                    }
                    positionAttribute.needsUpdate = true;
                    t.current = 0;
                }
            });
        }, 100 / amp);
        return () => clearInterval(timer);
    }, [amp, size]);

    // 独立切换 sprite 纹理，形成亮度与形状变化。
    useEffect(() => {
        let i = 0;
        const interval = setInterval(() => {
            requestAnimationFrame(() => {
                points.current.material.map = sprites[i++ % sprites.length];
            });
        }, 100 / amp);
        return () => clearInterval(interval);
    }, [sprites, amp]);

    useFrame((_, delta) => {
        // 每帧扩大点云并减小粒子尺寸，模拟火花向外扩散后熄灭。
        t.current += delta * 2;
        points.current.scale.setScalar(t.current);
        points.current.material.size = 2 * size - t.current;
    });

    return (
        <points ref={points} position={position} {...props}>
            <circleBufferGeometry args={[1, 16]} />
            <pointsMaterial
                size={0.5}
                map={sprites[0]}
                transparent
                depthTest={false}
                color="#FFF8E5"
            />
        </points>
    );
}

export default Sparkles;
